import React from "react"
import { RoundedButton } from "@omnichannel/ace-b2b-elements"

const CommonRoundedButton = React.memo(props => (
  <RoundedButton
    fontSize={"1.6rem"}
    fontWeight={"600"}
    height={"4.4rem"}
    width="100%"
    // borderRadius={"6rem"}
    {...props}
  />
))

export default CommonRoundedButton
